import { render, staticRenderFns } from "./chat-image-viewer.vue?vue&type=template&id=153e7523&scoped=true"
import script from "./chat-image-viewer.vue?vue&type=script&lang=js"
export * from "./chat-image-viewer.vue?vue&type=script&lang=js"
import style0 from "./chat-image-viewer.vue?vue&type=style&index=0&id=153e7523&prod&lang=less&scoped=true"
import style1 from "./chat-image-viewer.vue?vue&type=style&index=1&id=153e7523&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e7523",
  null
  
)

export default component.exports